module.exports = "/images/goto_logo.svg?e1cf8c58f4c532263f0329b2f5b037a4";


//////////////////
// WEBPACK FOOTER
// ./public/images/svg/goto_logo.svg
// module id = 1ft1
// module chunks = 0